import React from 'react';

const RequestItem = ({
  request,
  styles,
  theme,
  getStatusIcon,
  getStatusColor,
  formatDate,
  documentTypes,
  t,
  highlighted = false,
}) => {
  const StatusIcon = getStatusIcon(request.status);
  const isUpload = request.requestType?.startsWith('upload:');
  const baseType = isUpload ? request.requestType.replace('upload:', '') : request.requestType;
  const docType = documentTypes.find((ty) => ty.id === baseType);
  const displayName = docType?.name || baseType || request.requestType;

  return (
    <div
      id={`docreq-${request.id}`}
      style={{
        ...styles.requestItem,
        // Notification deep-link focus ring (?documentId=...)
        ...(highlighted
          ? {
              outline: '2px solid #3b82f6',
              outlineOffset: '2px',
              borderRadius: styles.requestItem?.borderRadius || '12px',
            }
          : {}),
      }}
    // onMouseEnter={(e) => {
    //   e.currentTarget.style.background =
    //     theme === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.05)";
    //   e.currentTarget.style.transform = "translateX(6px)";
    //   e.currentTarget.style.boxShadow =
    //     theme === "dark"
    //       ? "0 12px 32px rgba(0, 0, 0, 0.4)"
    //       : "0 12px 32px rgba(0, 0, 0, 0.1)";
    // }}
    // onMouseLeave={(e) => {
    //   e.currentTarget.style.background =
    //     theme === "dark" ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.03)";
    //   e.currentTarget.style.transform = "translateX(0)";
    //   e.currentTarget.style.boxShadow =
    //     theme === "dark"
    //       ? "0 8px 24px rgba(0, 0, 0, 0.3)"
    //       : "0 8px 24px rgba(0, 0, 0, 0.06)";
    // }}
    >
      <div style={styles.requestIcon(request.status)}>
        <StatusIcon size={28} color={getStatusColor(request.status)} />
      </div>

      <div style={styles.requestContent}>
        <h4 style={styles.requestTitle}>{isUpload ? `📤 ${displayName}` : displayName}</h4>
        <div style={styles.requestMeta}>
          <span>{t.requested} {formatDate(request.requestedDate)}</span>
          {request.reason && (
            <>
              <span>•</span>
              <span>{request.reason}</span>
            </>
          )}
        </div>
      </div>

      <span style={styles.statusBadge(request.status)}>{request.status}</span>
    </div >
  );
};

export default RequestItem;